const Mn = require('backbone.marionette');
const Template = require('common/ui/template/error.hbs');
const i18n = require('i18next');

module.exports = Mn.View.extend({
    className: 'jumbotron',
    template: Template,

    username: function() {
        const user = this.getOption('user');
        return user.get('name');
    },

    userImage: function() {
        const user = this.getOption('user');
        return user.get('image_url');
    },

    currentUserMessage: function() {
        return i18n.t('error:error_page.permission_error.current_user');
    },

    serializeData: function() {
        const isPermissionError = this.getOption('statusCode') == 403;
        const accountsPageURL = `/accounts?dst_url=${encodeURIComponent(window.location.pathname + window.location.search + window.location.hash)}`;

        return {
            title: this.getOption('title'),
            info: this.getOption('info'),
            isPermissionError: isPermissionError,
            username: this.username(),
            userImage: this.userImage(),
            currentUserMessage: this.currentUserMessage(),
            accountsPageURL: accountsPageURL
        }
    }
});



// WEBPACK FOOTER //
// ./common/ui/view/error.js